(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  let resizeTimer = null;
  let running = false;

  const getParts = () => {
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return null;

    const infoWrapper = productInfo.querySelector('.product__info-wrapper');
    const infoPanel = productInfo.querySelector('.product__info-container');
    const mediaCard =
      productInfo.querySelector('.product__media-wrapper .product__media-item:first-child .global-media-settings') ||
      productInfo.querySelector('.product__media-wrapper .global-media-settings');

    if (!infoWrapper || !infoPanel || !mediaCard) return null;
    return { infoWrapper, infoPanel, mediaCard };
  };

  const align = () => {
    if (running) return;
    const parts = getParts();
    if (!parts) return;

    const { infoWrapper, infoPanel, mediaCard } = parts;

    if (!desktop.matches) {
      infoWrapper.style.removeProperty('--kp-product-align-y');
      return;
    }

    running = true;
    infoWrapper.style.setProperty('--kp-product-align-y', '0px');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const mediaTop = mediaCard.getBoundingClientRect().top;
        const panelTop = infoPanel.getBoundingClientRect().top;
        const delta = Math.round(mediaTop - panelTop);
        infoWrapper.style.setProperty('--kp-product-align-y', `${delta}px`);
        running = false;
      });
    });
  };

  const schedule = () => requestAnimationFrame(align);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(schedule, 120);
  });
  document.addEventListener('shopify:section:load', schedule);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule).catch(() => {});
  }
})();
